<template>
  <div>
    <div v-if="hasNotifications" class="in-page-notifications">
      <notification-block
        v-for="(notification, index) in notifications"
        :key="index"
        :notification="notification"
        :simple="true"
        @refresh="refreshNotifications"
      />
    </div>
    <span v-if="!hasNotifications" class="text-center">{{ $t('No new notifications found') }}</span>
  </div>
</template>

<script>
import NotificationBlock from "@/components/header/NotificationBlock";

export default {
  name: "HomepageNotifications",
  components: {NotificationBlock},
  computed: {
    notifications: function () {
      return this.$store.state.NOTIFICATIONS;
    },
    hasNotifications: function () {
      return (Array.isArray(this.notifications)) ? this.notifications.length > 0 : false;
    },
  },
  methods: {
    refreshNotifications: function() {
      this.$store.dispatch('getNotifications');
    }
  }
}
</script>

<style scoped lang="scss">
.in-page-notifications {
  &::v-deep .b-toast {
    max-width: none;
    .toast {
      max-width: none;
    }
  }
}
</style>
